    <!-- Mensajes -->
    <div class="chat-messages" #chatContainer id="chat-messages">
      <div *ngFor="let message of view.messages; let i = index" class="message" [ngClass]="{
          'user-message': message.type === 'user',
          'system-message': message.type === 'system',
          'selected': view.isMessageSelected(message)
        }" id="chat-message-{{i}}" (dblclick)="view.selectMessage(message)"
        (mouseenter)="view.onBotMessageHintEnter(message, $event)" (mouseleave)="view.onBotMessageHintLeave()">
        <div class="message-avatar-stack" id="chat-message-avatar-stack-{{i}}">
          <div class="message-avatar" id="chat-message-avatar-{{i}}">
            <ng-container *ngIf="message.type === 'user'">
              <div class="user-avatar-small"
                [style.backgroundImage]="'url(' + (view.userAvatarUrl || 'assets/images/default-avatar.png') + ')'"
                aria-hidden="true"></div>
            </ng-container>
            <ng-container *ngIf="message.type === 'system'">
              <i class="fas fa-robot" id="chat-message-avatar-icon-{{i}}"></i>
            </ng-container>
          </div>
          <button *ngIf="message.type === 'user'" type="button" class="message-edit-btn"
            (click)="view.editMessageToInput(message)" [attr.aria-label]="view.translate('chat.edit_message') + ' ' + i"
            id="chat-message-edit-{{i}}" title="{{ view.translate('chat.edit') }}">
            <i class="fas fa-pen"></i>
          </button>
        </div>
        <div class="message-content" id="chat-message-content-{{i}}">
          <div *ngIf="view.shouldRenderMessageAsHtml(message); else plainMessageText"
            class="message-text message-text-html" [innerHTML]="message.content | safeBotHtml"
            id="chat-message-text-{{i}}" [attr.data-task]="message.id ? message.id : null"></div>
          <ng-template #plainMessageText>
            <div class="message-text" [textContent]="view.displayMessageContent(message)" id="chat-message-text-{{i}}"
              [attr.data-task]="message.id ? message.id : null"></div>
          </ng-template>
          <!-- Badge por-mensaje: rol experto con el que se envio la pregunta -->
          <div class="expert-role-badge"
            *ngIf="view.hasExpertRoleBadge(message) && view.expertRoleBadge(message.expertRole!) as badge"
            id="chat-message-expert-role-{{i}}"
            [attr.aria-label]="view.translate('chat.expertRole.messageBadge') + ': ' + badge.name"
            title="{{ view.translate('chat.expertRole.messageBadge') }}: {{ badge.name }}">
            <i class="expert-role-badge-icon {{ badge.icon }}" aria-hidden="true"></i>
            <span class="expert-role-badge-name">{{ badge.name }}</span>
          </div>
          <!-- Fase 4: grounding (evidencia, claims, citas, facetas). Todo opcional y aditivo:
               si el backend no envía los campos, ningún bloque se renderiza. -->
          <ng-container *ngIf="message.type === 'system'">
            <!-- Badge de estado de evidencia -->
            <div class="grounding-evidence" *ngIf="message.evidenceStatus as evidence"
              [ngClass]="'grounding-evidence-' + evidence"
              id="chat-grounding-evidence-{{i}}"
              [attr.aria-label]="view.translate('chat.grounding.evidence.aria') + ': ' + view.translate(view.evidenceStatusLabelKey(evidence))"
              title="{{ view.translate('chat.grounding.evidence.aria') }}">
              <i class="fas fa-shield-halved" aria-hidden="true"></i>
              <span class="grounding-evidence-label">{{ view.translate(view.evidenceStatusLabelKey(evidence)) }}</span>
            </div>
            <!-- Advertencia real (P2-1): el chip de arriba nombra el estado; esto dice qué
                 significa para la respuesta que se está leyendo. Acompaña a la prosa del
                 LLM, no la reescribe. Solo para los estados que lo ameritan. -->
            <div class="grounding-warning" role="note"
              *ngIf="view.evidenceWarningKey(message.evidenceStatus) as warningKey"
              id="chat-grounding-warning-{{i}}">
              <i class="fas fa-triangle-exclamation" aria-hidden="true"></i>
              <span class="grounding-warning-text">{{ view.translate(warningKey) }}</span>
            </div>
          </ng-container>
          <!-- R2-EXT: documentos candidatos encontrados para el resumen (¿son estos?). -->
          <ul class="generation-candidates" *ngIf="message.candidateDocuments?.length"
            id="chat-generation-candidates-{{i}}">
            <li class="generation-candidate" *ngFor="let doc of message.candidateDocuments">
              <i class="fas fa-file-lines" aria-hidden="true"></i>
              <span class="generation-candidate-name">{{ doc.filename }}</span>
            </li>
          </ul>
          <div class="message-links" *ngIf="message.actions?.length">
            <ng-container *ngFor="let action of message.actions">
              <button *ngIf="action.kind === 'task' && action.taskId" type="button" class="btn btn-link btn-sm px-0"
                (click)="view.openTaskAction(action.taskId, $event)">
                {{ action.label }}
              </button>
              <a *ngIf="action.kind === 'external' && action.href" class="btn btn-link btn-sm px-0"
                [href]="action.href" target="_blank" rel="noopener noreferrer">
                {{ action.label }}
              </a>
              <!-- Confirmar: encola la generación y navega a Mis Resúmenes. -->
              <button *ngIf="action.kind === 'generate' && action.generate" type="button" class="btn btn-primary btn-sm generation-proposal-btn"
                (click)="view.openGenerateAction(action, $event)">
                <i class="fas fa-wand-magic-sparkles"></i>
                {{ action.label }}
              </button>
              <!-- Ajustar: abre el asistente para cambiar la selección de documentos. -->
              <button *ngIf="action.kind === 'route' && action.route" type="button" class="btn btn-outline-secondary btn-sm generation-proposal-btn"
                (click)="view.openRouteAction(action, $event)">
                <i class="fas fa-sliders"></i>
                {{ action.label }}
              </button>
            </ng-container>
          </div>
          <!-- Per-message actions (copy, like, dislike) -->
          <div class="message-actions" *ngIf="message.type === 'system'" id="chat-message-actions-{{i}}">
            <button type="button" class="btn btn-sm btn-outline-secondary" (click)="view.copyMessage(message, i)"
              title="{{ view.translate('chat.copy_message') }}">
              <i class="fas fa-copy"></i>
            </button>
            <button type="button" class="btn btn-sm btn-outline-success" (click)="view.toggleFeedbackForMessage(i, true)"
              [class.active]="view.feedbackTargetIndex === i && view.feedbackLike === true"
              title="{{ view.translate('chat.like_message') }}">
              <i class="fas fa-thumbs-up"></i>
            </button>
            <button type="button" class="btn btn-sm btn-outline-danger" (click)="view.toggleFeedbackForMessage(i, false)"
              [class.active]="view.feedbackTargetIndex === i && view.feedbackLike === false"
              title="{{ view.translate('chat.dislike_message') }}">
              <i class="fas fa-thumbs-down"></i>
            </button>
            <!-- Deselect button shown when this message is selected -->
            <button *ngIf="view.isMessageSelected(message)" type="button" class="btn btn-sm btn-outline-secondary ms-1"
              (click)="view.deselectMessage($event)" title="{{ view.translate('chat.deselect_message') }}">
              <i class="fas fa-times-circle"></i>
            </button>
            <span class="copy-confirmation" *ngIf="view.copiedMessageIndex === i">{{ view.translate('chat.copied') }}</span>
          </div>
          <!-- Enlaces de descarga de los documentos fuente de la respuesta (derivados por codigo, nunca por el LLM) -->
          <ng-container *ngIf="message.type === 'system' && view.getAnswerSourceDocuments(message) as answerDocs">
          <div class="answer-document-download"
            *ngIf="answerDocs.length > 0"
            id="chat-answer-download-{{i}}">
            <span class="answer-document-download-title">{{ view.translate('chat.documents') }}:</span>
            <button type="button" class="btn btn-sm btn-outline-primary answer-document-download-btn"
              *ngFor="let answerDoc of answerDocs; let di = index"
              (click)="view.downloadAnswerDocument(answerDoc.documentId, $event)"
              [attr.aria-label]="view.translate('chat.download_document') + ' ' + (answerDoc.filename || view.translate('chat.document'))"
              title="{{ view.translate('chat.download_document') }}"
              id="chat-answer-download-{{i}}-{{di}}">
              <i class="fas fa-download"></i>
              <span class="answer-document-download-name">{{ answerDoc.filename || view.translate('chat.document') }}</span>
            </button>
          </div>
          </ng-container>
          <!-- Inline feedback panel for a specific message -->
          <div class="feedback-panel-inline" *ngIf="view.feedbackTargetIndex === i && !view.feedbackSent"
            id="chat-feedback-inline-{{i}}">
            <div class="feedback-inline-row">
              <div class="feedback-inline-rating" style="gap:4px; display:flex; align-items:center;">
                <ng-container *ngFor="let star of [1,2,3,4,5]; let si = index">
                  <i [ngClass]="view.getStarClass(si + 1)" (mouseenter)="view.setHoverRating(si + 1)"
                    (mouseleave)="view.setHoverRating(0)" (click)="view.setFeedbackRating(si + 1)"
                    [style.color]="view.getStarColor(si + 1)" style="cursor:pointer;"
                    [attr.title]="view.translate('chat.star_rating_title').replace('{{count}}', (si + 1).toString())"></i>
                </ng-container>
                <span *ngIf="view.feedbackRating > 0" style="margin-left:8px; font-weight:500;">{{ view.feedbackRating }} /
                  5</span>
              </div>
              <div class="feedback-inline-actions">
                <button class="btn btn-sm btn-outline-success" (click)="view.sendFeedback(view.feedbackLike)"> <i
                    class="fas fa-check"></i> </button>
                <button class="btn btn-sm btn-outline-secondary" (click)="view.closeInlineFeedback()"> <i
                    class="fas fa-times"></i> </button>
              </div>
            </div>
            <textarea class="form-control mt-2" rows="2" [(ngModel)]="view.feedbackComment"
              placeholder="{{ view.translate('chat.feedback_comment') }}"></textarea>
          </div>
          <div class="message-time" id="chat-message-time-{{i}}">{{ message.timestamp | date: 'short' }}</div>
        </div>
      </div>

      <!-- Indicador de escritura -->
      <div *ngIf="view.isLoading" class="message system-message typing-indicator" id="chat-typing-indicator">
        <div class="message-avatar" id="chat-typing-avatar">
          <i class="fas fa-robot" id="chat-typing-icon"></i>
        </div>
        <div class="message-content" id="chat-typing-content">
          <div class="typing-dots" id="chat-typing-dots">
            <span></span><span></span><span></span>
          </div>
          <span class="typing-label">{{ view.translate('chat.typing') || 'Escribiendo...' }}</span>
        </div>
      </div>

      <!-- Error -->
      <div *ngIf="view.error" class="error-message" role="alert" id="chat-error-message">
        <i class="fas fa-exclamation-circle" id="chat-error-icon"></i>
        <span id="chat-error-text">{{ view.error }}</span>
      </div>

      <!-- Feedback -->
      <!-- Feedback (alineado como system-message) -->
      <div *ngIf="view.showFeedback && !view.feedbackSent" class="message system-message" id="chat-feedback-panel">
        <div class="message-avatar" id="chat-feedback-avatar">
          <i class="fas fa-robot" id="chat-feedback-icon"></i>
        </div>
        <div class="message-content feedback-panel" id="chat-feedback-content">
          <div class="feedback-question" id="chat-feedback-question">{{ view.translate('chat.feedback') }}</div>
          <div class="d-flex align-items-center" style="gap: 24px; margin-bottom: 8px;">
            <div class="feedback-rating d-flex align-items-center" id="chat-feedback-rating" style="gap: 2px;">
              <ng-container *ngFor="let star of [1,2,3,4,5]; let i = index">
                <i [ngClass]="view.getStarClass(i + 1)" (mouseenter)="view.setHoverRating(i + 1)" (mouseleave)="view.setHoverRating(0)"
                  (click)="view.setFeedbackRating(i + 1)" [style.color]="view.getStarColor(i + 1)"
                  style="font-size: 2em; cursor: pointer; margin-right: 2px;"
                  [attr.title]="view.translate('chat.star_rating_title').replace('{{count}}', (i + 1).toString())"></i>
              </ng-container>
              <span class="rating-value"
                style="margin-left: 8px; font-weight: 500; color: var(--primary); vertical-align: middle;"
                *ngIf="view.feedbackRating > 0">
                {{ view.feedbackRating }} / 5
              </span>
            </div>
            <div class="feedback-buttons" id="chat-feedback-buttons" style="display: flex; gap: 8px;">
              <button class="btn btn-sm btn-outline-success align-middle" (click)="view.sendFeedback(true)"
                id="chat-feedback-yes-btn">
                <i class="fas fa-thumbs-up" id="chat-feedback-yes-icon"></i> {{ view.translate('chat.yes') }}
              </button>
              <button class="btn btn-sm btn-outline-danger align-middle" (click)="view.sendFeedback(false)"
                id="chat-feedback-no-btn">
                <i class="fas fa-thumbs-down" id="chat-feedback-no-icon"></i> {{ view.translate('chat.no') }}
              </button>
            </div>
          </div>
          <div class="feedback-comment" id="chat-feedback-comment">
            <textarea [(ngModel)]="view.feedbackComment" placeholder="{{ view.translate('chat.feedback_comment') }}" rows="2"
              class="form-control" id="chat-feedback-comment-input"
              style="min-height: 80px; height: 120px; resize: vertical;"></textarea>
          </div>
        </div>
      </div>


      <div *ngIf="view.feedbackSent" class="feedback-confirmation" id="chat-feedback-confirmation">
        <i class="fas fa-check-circle" id="chat-feedback-confirmation-icon"></i>
        <span id="chat-feedback-confirmation-text">{{ view.translate('chat.feedback_thanks') }}</span>
      </div>
    </div>
